import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../App';
import img from '../assets/logo.png';

const Navbar = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navLinks = [
    { path: '/', label: t.nav.home },
    { path: '/about', label: t.nav.about },
    { path: '/services', label: t.nav.services },
    { path: '/products', label: t.nav.products },
    { path: '/fpc', label: t.nav.fpc },
    { path: '/export', label: t.nav.export },
    { path: '/mushroom', label: t.nav.mushroom },
    { path: '/contact', label: t.nav.contact },
  ];

  return (
    <nav className="bg-green-800 text-white shadow-lg sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" aria-label="Kanhaiya Krushi Home">
            <img src={img} alt="Kanhaiya Krushi Logo" className="w-10 h-10 bg-white rounded" />
            <div className="hidden md:block">
              <h1 className="text-xl font-bold">Kanhaiya Krushi</h1>
              <p className="text-xs text-green-200">Seva Kendra</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg transition-all duration-300 text-sm ${
                  isActive(link.path)
                    ? 'bg-green-700 font-semibold'
                    : 'hover:bg-green-700'
                }${
                  link.path === '/mushroom'
                    ? ' border border-yellow-400 text-yellow-300 hover:bg-green-700'
                    : ''
                }`}
              >
                {link.path === '/mushroom' ? (
                  <span className="flex items-center gap-1">
                    🍄 {link.label}
                  </span>
                ) : link.label}
              </Link>
            ))}
          </div>

          {/* Language Toggle & Mobile Menu Button */}
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="bg-green-700 px-4 py-2 rounded-lg hover:bg-green-600 transition-all duration-300 font-semibold text-sm"
              aria-label={language === 'en' ? 'Switch to Marathi' : 'Switch to English'}
            >
              {language === 'en' ? 'मराठी' : 'English'}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden focus:outline-none"
              aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMobileMenuOpen}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden pb-4">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 rounded-lg transition-all duration-300 ${
                    isActive(link.path)
                      ? 'bg-green-700 font-semibold'
                      : 'hover:bg-green-700'
                  }${
                    link.path === '/mushroom'
                      ? ' border border-yellow-400 text-yellow-300'
                      : ''
                  }`}
                >
                  {link.path === '/mushroom' ? (
                    <span className="flex items-center gap-1">🍄 {link.label}</span>
                  ) : link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
